import React from 'react';

const RemixLogo = () => {
  return <img src='/skill-icons/remix.png' alt='remix-logo' />;
};

export default RemixLogo;
